/** @jsxImportSource theme-ui */
import { Button as ThemeUIButton, Box, Heading, useThemeUI } from "theme-ui";
import { useSelector } from "react-redux";

import { useTranslation } from "hooks";
import { ProductButton, Button } from "components";
import { ArrowLeftIcon, ArrowRightIcon } from "components/icons";
import { selectProductSelectorStyle } from "store/app";
import ProductSelectorCarousel from "./ProductSelectorCarousel";
import * as styles from "./ProductsSelectorV1.styles";
import { getHrefWithHostname } from "utils";

export default function ProductsSelectorV1({
  title,
  products = [],
  selectedProduct,
  selectProduct,

  position,
  top,
  left,
  right,
  containerTop,
  labelTop,
  labelLeft,
  customCardLayout,
}) {
  const {
    theme: { isDesktop },
  } = useThemeUI();
  const { t } = useTranslation();

  const productSelectorStyle = useSelector(selectProductSelectorStyle);

  const displayCarousel = productSelectorStyle === "CAROUSEL";

  return (
    <Box sx={styles.container({ displayCarousel })}>
      <Heading
        as="h1"
        sx={
          isDesktop
            ? styles.desktopHeading({ labelTop, labelLeft })
            : styles.heading
        }
      >
        {title}
      </Heading>

      {displayCarousel ? (
        <ProductSelectorCarousel
          products={products}
          selectProduct={selectProduct}
          selectedProduct={selectedProduct}
          productSelectorStyles={styles}
          itemWidth={300}
        />
      ) : (
        <Box
          sx={
            isDesktop
              ? styles.desktopCardsContainer({
                  containerTop,
                  customCardLayout,
                })
              : styles.cardsContainer
          }
        >
          {products
            .filter(({ id }) => !selectedProduct || id === selectedProduct.id)
            .filter((product) => !product.hideProduct)
            .map(
              ({
                id,
                isDisabled,
                productButtonLinkOverride,
                category: {
                  productButtonLogo,
                  logo,
                  productButtonProps,
                  additionalLinks,
                },
              }) => (
                <Box
                  key={id}
                  sx={
                    isDesktop
                      ? styles.desktopCard({
                          position,
                          top,
                          left,
                          right,
                          customCardLayout,
                        })
                      : styles.card
                  }
                >
                  <ProductButton
                    logo={productButtonLogo || logo}
                    isSelected={id === selectedProduct?.id}
                    isDisabled={isDisabled}
                    productButtonLinkOverride={productButtonLinkOverride}
                    onClick={() => {
                      selectProduct(id);
                    }}
                    {...productButtonProps}
                  />
                  {additionalLinks && (
                    <Box sx={styles.additionalLinks}>
                      {additionalLinks.map(({ text, href }) => {
                        return (
                          <Button
                            key={text}
                            theme="light"
                            href={getHrefWithHostname(href)}
                            sx={styles.additionalLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            iconAfter={<ArrowRightIcon />}
                          >
                            {text}
                          </Button>
                        );
                      })}
                    </Box>
                  )}

                  {id === selectedProduct?.id && (
                    <ThemeUIButton
                      variant="unstyled"
                      onClick={() => selectProduct("")}
                      sx={styles.changeStickButton}
                    >
                      <ArrowLeftIcon />
                      {t("Change Stick")}
                    </ThemeUIButton>
                  )}
                </Box>
              )
            )}
        </Box>
      )}
    </Box>
  );
}
